import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './index.css';

const initAnalytics = () => {
  const key = import.meta.env.VITE_POSTHOG_KEY;
  if (!key) return;
  import('posthog-js').then(({ default: posthog }) => {
    posthog.init(key, {
      api_host: 'https://app.posthog.com',
      autocapture: true,
      capture_pageview: true,
    });
  }).catch(() => {});
};

initAnalytics();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
